// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"30":"57d1bd93","604":"deb1f238","968":"40678f10","982":"40678f10"}[chunkId] + ".chunk.css";
};